const iterations = [
  {
    id: 1,
    capacity: { 123: 40, 345: 40 },
  },
  {
    id: 2,
    capacity: { 123: 40, 345: 35 },
  },
  {
    id: 3,
    capacity: { 123: 40, 345: 35 },
  },
  {
    id: 4,
    capacity: { 123: 40, 345: 35 },
  },
  {
    id: 5,
    capacity: { 123: 40, 345: 35 },
  },
  {
    id: 6,
    capacity: { 123: 40, 345: 35 },
  },
  {
    id: 7,
    capacity: { 123: 40, 345: 35 },
  },
];

export { iterations };
